import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { GeofencingMgtService } from '../../services/geofencing-mgt.service';

interface IeditGeofenceProfileModalContext {
  data: any;
  title?: string;
}
@Component({
  selector: 'app-edit-geofence-modal',
  templateUrl: './edit-geofence-modal.component.html',
  styleUrls: ['./edit-geofence-modal.component.scss'],
})
export class EditGeofenceModalComponent implements OnInit {
  success: any;
  error: any;
  profileForm: FormGroup;
  pending: boolean;

  extraData: any;
  formSubmitAttempt: boolean;

  // Dynamic countries array
  countries: any[] = [];
  selectedCountries: any[] = [];
  selectedCountryNames: string = '';

  constructor(
    public modal: SuiModal<IeditGeofenceProfileModalContext, void, void>,
    private fb: FormBuilder,
    private geofenceSvc: GeofencingMgtService
  ) {
    this.profileForm = this.fb.group({
      profileName: ['', Validators.required],
      countries: ['', Validators.required],
    });
    this.extraData = this.modal.context.data;
  }

  ngOnInit(): void {
    // Fetch countries when component initializes
    this.fetchCountries();

    // If editing an existing profile, pre-select countries after fetching
    if (this.extraData.isAdd == false) {
      this.profileForm.patchValue(this.extraData);
    }

    console.log('modal data ', this.modal.context.data);
  }

  fetchCountries() {
    this.pending = true;
    this.geofenceSvc.getAllCountries().subscribe({
      next: (data: any) => {
        this.pending = false;
        // Combine all rows into a single array and reverse
        this.countries = data.rows.flat();
        this.countries.reverse();

        // If editing an existing profile, pre-select countries
        if (!this.extraData.isAdd && this.extraData.countries) {
          const countryNames = this.extraData.countries.split(',');
          this.selectedCountries = this.countries.filter((country) =>
            countryNames.includes(country.countryName)
          );
          this.selectedCountryNames = this.selectedCountries
            .map((c) => c.countryName)
            .join(',');
          this.profileForm.patchValue({
            countries: this.selectedCountryNames,
          });
        }
      },
      error: (error) => {
        this.pending = false;
        this.error = error.error ? error.error : error;
      },
    });
  }

  isFieldValid(field: string) {
    return (
      (!this.profileForm.get(field).valid &&
        this.profileForm.get(field).touched) ||
      (this.profileForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  toggleCountrySelection(country: any) {
    const index = this.selectedCountries.findIndex(
      (c) => c.countryName === country.countryName
    );
    if (index === -1) {
      this.selectedCountries.push(country);
    } else {
      this.selectedCountries.splice(index, 1);
    }
    this.selectedCountryNames = this.selectedCountries
      .map((c) => c.countryName)
      .join(',');
    this.profileForm.patchValue({
      countries: this.selectedCountryNames,
    });
  }

  getSelectedCountriesText(): string {
    return this.selectedCountries
      .map((country) => country.countryName)
      .join(', ');
  }

  isCountrySelected(country: any): boolean {
    return this.selectedCountries.some(
      (c) => c.countryName === country.countryName
    );
  }

  add() {
    this.formSubmitAttempt = true;
    this.pending = false;
    if (this.profileForm.valid) {
      this.error = null;
      this.pending = true;
      this.success = null;
      let body = {
        profileName: this.profileForm.value.profileName,
        countries: this.selectedCountryNames,
      };
      if (this.modal.context.data.isAdd == true) {
        this.geofenceSvc.addGeofenceProfile(body).subscribe({
          next: () => {
            this.pending = false;
            this.success = 'Geofence Profile Added';
            setTimeout(() => this.modal.approve(), 500);
          },
          error: (error: any) => {
            this.error = 'An Error Occurred';
            this.pending = false;
          },
        });
      }
    }
  }

  update() {
    this.formSubmitAttempt = true;
    this.pending = false;
    if (this.profileForm.valid) {
      this.error = null;
      this.pending = true;
      this.success = null;
      if (this.modal.context.data.isAdd == false) {
        this.geofenceSvc
          .editGeofenceProfile({
            geofenceProfileId: this.modal.context.data.profileId,
            body: {
              profileName: this.profileForm.value.profileName,
              countries: this.selectedCountryNames,
            },
          })
          .subscribe({
            next: () => {
              this.pending = false;
              this.success = 'Geofence Profile Updated';
              setTimeout(() => this.modal.approve(), 500);
            },
            error: (error: any) => {
              this.error = error?.error?.message
                ? error?.error?.message
                : error;
              this.pending = false;
            },
          });
      }
    }
  }
}

export class editGeofenceProfileModal extends ComponentModalConfig<
  IeditGeofenceProfileModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
    super(EditGeofenceModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
